import { Environment } from '@core/interfaces/environment.interface';

export const environment: Environment = {
  production: false,
  baseURL: 'https://api.dev.projectcarlog.com',
  apiURL: 'https://api.dev.projectcarlog.com/api'
};
